function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  x: 12,
  y: 6,
  width: 6,
  height: 2,
  rx: 1,
  fill: "#908E8E",
  className: "sort-icon"
});

var _ref3 = /*#__PURE__*/React.createElement("rect", {
  x: 12,
  y: 11,
  width: 8,
  height: 2,
  rx: 1,
  fill: "#908E8E",
  className: "sort-icon"
});

var _ref4 = /*#__PURE__*/React.createElement("rect", {
  x: 12,
  y: 16,
  width: 10,
  height: 2,
  rx: 1,
  fill: "#908E8E",
  className: "sort-icon"
});

var _ref5 = /*#__PURE__*/React.createElement("rect", {
  x: 5,
  y: 16,
  width: 10,
  height: 2,
  rx: 1,
  transform: "rotate(-90 5 16)",
  fill: "#908E8E",
  className: "sort-icon"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M9 14L6 17L3 14",
  stroke: "#908E8E",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  className: "sort-icon__arrow"
});

function SvgIcSort(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSort);
export default __webpack_public_path__ + "static/media/ic-sort.7227a9e9.svg";
export { ForwardRef as ReactComponent };